/* eslint-disable no-unused-vars */
import { useNavigate, useParams } from 'react-router-dom'

import useCollaborator from '../../_hooks/useCollaborator'
import { useGlobalContext } from '../../../../context/ContextGlobal'
import { TryCatch } from '../../../../utils/general'
import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { AlertFunctional } from '../../../../components/ui/alert/AlertFunctional'
import { Button } from '../../../../components/ui/button'
import { DeleteUserAuthenticatorFromUid } from '../../../../firebase/functions'

export const ConfirmDelete = () => {
  const { user, token } = useCollaborator()

  const { uuid } = useParams()

  const { alerts, setAlerts, setLoading } = useGlobalContext()

  const navigate = useNavigate()

  const deleteAcc = async (uid) => {
    if (!uid) {
      throw new Error('Não foi possível recuperar o token de autenticação.')
    }

    const deleteaccount = await DeleteUserAuthenticatorFromUid(uid)

    return navigate('/colaboradores')
  }

  const handleDeleteAccount = async (uid) => {
    await TryCatch(
      async () => {
        await deleteAcc(uid)
      },
      setLoading,
      setAlerts,
    )
  }

  return (
    Object.keys(user).length > 0 && (
      <Page.Root
        style={{
          width: '375px', // Largura média de um celular (iPhone X, por exemplo)
          maxWidth: '100vw', // Garante que não ultrapasse a largura da tela
          margin: '0 auto', // Centraliza no modo web
        }}
      >
        <Page.Content>
          <Column.Root>
            <Column.Content
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                margin: '2rem 0',
              }}
            >
              <h1 className="title is-size-3 has-text-centered">Exclusão de Conta</h1>

              <p className="subtitle is-size-5 mt-4">Tem certeza que deseja prosseguir com a exclusão da conta?</p>
              <p className="subtitle is-size-5 mt-4" style={{ color: 'red' }}>
                Essa ação é irreversível.
              </p>
            </Column.Content>
          </Column.Root>
          <Column.Root className="mt-6">
            <Column.Content style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <Button.Bt
                className="is-danger"
                action={async () => {
                  await handleDeleteAccount(uuid)
                }}
              >
                EXCLUIR
              </Button.Bt>
              <Button.Bt
                action={() => {
                  navigate('/colaboradores')
                }}
              >
                MANTER
              </Button.Bt>
            </Column.Content>
          </Column.Root>
          <div style={{ height: 40, marginTop: 150 }}>
            <p className="has-text-centered has-text-grey-light">by @Keap Staff Ltda., 2025</p>
          </div>
        </Page.Content>
        <AlertFunctional values={alerts} setValues={setAlerts}></AlertFunctional>
      </Page.Root>
    )
  )
}
